import { ModelSagres } from "@/types/model-sagres";

export class HistoricoManifestacao extends ModelSagres {
    idHistorico: number
    idManifestacao: number
    descHistorico: string
    tipoHistorico: string

    constructor(obj?: any) {
        super()
        if (obj.idHistorico) this.idHistorico = obj.idHistorico
        if (obj.idManifestacao) this.idManifestacao = obj.idManifestacao
        if (obj.descHistorico) this.descHistorico = obj.descHistorico
        if (obj.tipoHistorico) this.tipoHistorico = obj.tipoHistorico
    }
}